var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.isReadOnly
      ? _c("div", { staticClass: "my-4" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-lg-8" }, [
              _c("div", {}, [
                _c(
                  "div",
                  { staticClass: "row d-flex align-items-end" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-4" },
                      [
                        _c("label", { staticClass: "font-weight-bolder" }, [
                          _vm._v("Equipo:")
                        ]),
                        _c("custom-input", {
                          attrs: {
                            disabled: false,
                            fieldkey: "id",
                            fieldname: "name",
                            placeholder: ""
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name"
                          }
                        })
                      ],
                      1
                    ),
                    _c("action-button", {
                      attrs: {
                        disabled: false,
                        i: "fas fa-file-plus",
                        text: "Añadir",
                        variant: "success col-12 col-md-2 px-0"
                      },
                      on: {
                        click: function($event) {
                          return _vm.add()
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "custom-collapse",
          { attrs: { id: "equipments-collapse" } },
          _vm._l(_vm.value, function(item, key) {
            return _c(
              "custom-collapse-item",
              {
                key: `equipment-collapse-item-${key + 1}`,
                ref: `equipment-collapse-item-${key + 1}`,
                refInFor: true,
                staticClass: "my-3 collapse-item equipment bg-gray",
                class: { "rounded invalid": item.isValid === false },
                attrs: {
                  id: `equipment-collapse-item-${key + 1}`,
                  "auto-expand-collapse-enabled": false,
                  "button-icon": !_vm.isReadOnly
                    ? "far fa-times-circle color-red invalid"
                    : "",
                  disabled: false,
                  expanded: item.expanded,
                  "expanded-icon": "fas fa-plus-circle custom-reorganize-btn",
                  "icon-class-when-button-disabled":
                    "fas fa-grip-vertical flex-fill d-flex justify-content-end align-items-center",
                  "keep-btn-visible": false,
                  "parent-id": "equipments-collapse",
                  "read-only-icon": "fas fa-plus-circle color-gray-2",
                  title: item.name
                },
                on: {
                  actionButtonClick: function($event) {
                    return _vm.quit(item, key)
                  },
                  expandButtonClick: function($event) {
                    return _vm.expand(item, key)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title-left",
                      fn: function() {
                        return [
                          item.isValid === false
                            ? _c(
                                "span",
                                { staticClass: "badge badge-danger ml-2" },
                                [_vm._v(" Atención ")]
                              )
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              },
              [
                _c(
                  "validation-observer",
                  { ref: `equipmentObservers-${key}`, refInFor: true },
                  [
                    !_vm.isReadOnly
                      ? _c("validation-provider", {
                          attrs: {
                            "custom-messages": {
                              required: "El campo es requerido."
                            },
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      attrs: {
                                        "count-classes": [
                                          "d-block",
                                          "small-counter"
                                        ],
                                        "custom-error-msg": errors[0],
                                        error: errors[0],
                                        label: "Descripción:",
                                        maxlength: 3000,
                                        "show-char-count": ""
                                      },
                                      model: {
                                        value: item.description,
                                        callback: function($$v) {
                                          _vm.$set(item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm.isReadOnly
                      ? _c("div", [
                          _c("div", { staticClass: "my-2" }, [
                            _vm._v(" Descripción: ")
                          ]),
                          _c("label", { staticClass: "data-label" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("empty")(item.description)) +
                                " "
                            )
                          ])
                        ])
                      : _vm._e(),
                    !_vm.isReadOnly
                      ? _c("validation-provider", {
                          attrs: {
                            "custom-messages": {
                              required: "El campo es requerido."
                            },
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      attrs: {
                                        "count-classes": [
                                          "d-block",
                                          "small-counter"
                                        ],
                                        "custom-error-msg": errors[0],
                                        error: errors[0],
                                        label: "Especificaciones:",
                                        maxlength: 3000,
                                        "show-char-count": ""
                                      },
                                      model: {
                                        value: item.qualifications,
                                        callback: function($$v) {
                                          _vm.$set(item, "qualifications", $$v)
                                        },
                                        expression: "item.qualifications"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm.isReadOnly
                      ? _c("div", [
                          _c("div", { staticClass: "my-2" }, [
                            _vm._v(" Especificaciones: ")
                          ]),
                          _c("label", { staticClass: "data-label" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("empty")(item.qualifications)) +
                                " "
                            )
                          ])
                        ])
                      : _vm._e(),
                    !_vm.isReadOnly
                      ? _c("validation-provider", {
                          attrs: {
                            "custom-messages": {
                              required: "El campo es requerido."
                            },
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      attrs: {
                                        "count-classes": [
                                          "d-block",
                                          "small-counter"
                                        ],
                                        "custom-error-msg": errors[0],
                                        error: errors[0],
                                        label: "Recursos del Equipo:",
                                        maxlength: 3000,
                                        "show-char-count": ""
                                      },
                                      model: {
                                        value: item.resources,
                                        callback: function($$v) {
                                          _vm.$set(item, "resources", $$v)
                                        },
                                        expression: "item.resources"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm.isReadOnly
                      ? _c("div", [
                          _c("div", { staticClass: "my-2" }, [
                            _vm._v(" Recursos del Equipo: ")
                          ]),
                          _c("label", { staticClass: "data-label" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("empty")(item.resources)) +
                                " "
                            )
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }